'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { toast } from '@/shared/lib/toast';
import { registerRenderFailurePresenter } from '../model/render-failure-notice';

/** Mount once (WebSocketProvider): renders every render failure as a toast. */
export function useRenderFailureToasts(): void {
  const t = useTranslations('renderProgress');
  useEffect(
    () =>
      registerRenderFailurePresenter((message) => {
        toast.error(message ?? t('failed.render'), { duration: 8000 });
      }),
    [t]
  );
}
